import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEditorH2 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 640 512",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M296 64C282.8 64 272 74.75 272 88V224h-224V88C48 74.75 37.25 64 24 64S0 74.75 0 88v336C0 437.3 10.75 448 24 448s24-10.75 24-24V272h224v152C272 437.3 282.8 448 296 448S320 437.3 320 424V88C320 74.75 309.3 64 296 64zM616 400.2h-162.2l125.7-114.8c51.39-45.5 57.39-122.7 13.64-175.7c-21.81-26.44-52.56-42.47-86.58-45.13c-34-2.562-66.73 8.344-92.33 30.94l-25.66 22.66c-9.938 8.781-10.88 23.94-2.094 33.88c8.766 9.938 23.94 10.91 33.88 2.125l25.66-22.69c15.77-13.91 36.2-20.59 56.78-19.06c20.94 1.656 39.88 11.53 53.33 27.84c26.73 32.41 22.95 81.38-8.719 109.4l-171.6 156.8c-7.312 6.688-9.766 17.16-6.188 26.41c3.578 9.219 12.47 15.31 22.38 15.31h224c13.25 0 24-10.75 24-24S629.3 400.2 616 400.2z",
		fill: "currentColor"
	})
});
export default SvgEditorH2;
